import { useState } from "react";
import { Modal, Button as ButtonBootstrap } from "react-bootstrap";
import Maximize from "./Maximize";
import Minimize from "./Minimize";

const SmallModal = (props) => {
  const [fullscreen, setFullscreen] = useState(false);

  const handleIgnore = () => {
    props.handleIgnore(true);
  };

  const fullscreenHandler = () => {
    setFullscreen(!fullscreen);
  };

  return (
    <Modal
      show={props.show}
      onHide={props.hide}
      className="small-modal"
      fullscreen={fullscreen}
    >
      <Modal.Header closeButton style={{ position: "relative" }}>
        <Modal.Title size="h6">{props.title}</Modal.Title>
        <button
          style={{
            position: "absolute",
            right: "40px",
            top: "3px",
            padding: "0 0 1px 0",
            background: "none",
            border: "none",
          }}
          type="button"
          class="btn btn-primary"
          onClick={fullscreenHandler}
        >
          {fullscreen ? <Maximize /> : <Minimize />}
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>{props.content}</p>
      </Modal.Body>

      <Modal.Footer>
        {props.firstButton && (
          <ButtonBootstrap
            variant="primary"
            className="btnPrimary"
            onClick={handleIgnore}
          >
            {props.blueButton}
          </ButtonBootstrap>
        )}
        {props.secondButton && (
          <ButtonBootstrap
            variant="secondary"
            className="btnSecondary"
            onClick={props.hide}
          >
            Back to Budget Form
          </ButtonBootstrap>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SmallModal;
